import {CanActivateFn, Router} from '@angular/router';
import {inject, PLATFORM_ID} from '@angular/core';
import {TokenStorageService} from '@coreServices';
import {ROUTES} from '@coreConstant';
import {isPlatformServer} from "@angular/common";

export const authGuard: CanActivateFn = (route, state) => {

  const tokenStorageService = inject(TokenStorageService);
  const platformId = inject(PLATFORM_ID);
  const router = inject(Router);

  if (isPlatformServer(platformId)) return false;

  const restrictedRoutes = ['login', 'register', 'reset-password'];
  const currentUrl = state.url.split('?')[0];
  const isRestricted = restrictedRoutes.some(route => currentUrl.startsWith(`/${route}`));

  const currentUser = tokenStorageService.checkUserLoggedIn();

  // ✅ Check if localStorage has CREDIT_EARN.HIDE and redirect immediately
  // const creditData = localStorage.getItem('is_credit_earn_disabled');
  // if (creditData === '1') {
  //   return router.createUrlTree(['/']); // Redirect to Dashboard
  // }

  if(currentUrl && currentUrl == `/${ROUTES.ACCOUNT.ROOT}/${ROUTES.ACCOUNT.THE_GATHER_COMMITMENT}` )
  {
    const creditData = localStorage.getItem('is_credit_earn_disabled');
    if (creditData === '1') {
      return router.createUrlTree([ROUTES.HOME]); // Redirect to Dashboard
    }
  }

  if (currentUser) {
    return isRestricted ? router.createUrlTree([ROUTES.HOME]) : true;
  } else {
    return isRestricted ? true : router.createUrlTree([ROUTES.HOME]);
  }
};

export const productTypeGuard: CanActivateFn = (route, state) => {
  let allowedTypes = ['flooring', 'walling'];
  const router = inject(Router);

  const productType: any = route.paramMap.get('product-type');
  if (allowedTypes.includes(productType)) {
    return true;
  }
  router.navigate(['/' + ROUTES.PAGE_NOT_FOUND], {skipLocationChange: true});
  return false;
};
